import React ,{ useState }from 'react';
import "./Footer.css"
import { Link } from 'react-router-dom';
import useNavigation  from '../../utils/Navigation';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'
import { Modal, Button } from 'react-bootstrap';
import 'react-responsive-modal/styles.css';
import { FaWhatsapp, FaEnvelope, FaCopy } from 'react-icons/fa';

const Footer = () => {

  const pdfPaths = {
    termsOfService: require('./../../images/pdf/EC_DPRE_Trevi_T&C.pdf'),
    privacyPolicy: require('./../../images/pdf/EC_DPRE_Trevi_Privacy Policy.pdf'),
  };

  const openPDFInNewTab = (pdfPath) => {
    window.open(pdfPath, '_blank');
  };

    const navigateToSection = useNavigation();
    const [modalOpen, setModalOpen] = useState(false);

    const isMobileDevice = () => {
        return window.innerWidth <= 768; 
    };

    const showShareDialog = (url) => {
        if (isMobileDevice()) {
          setModalOpen(true);
        } else {
          copyToClipboard(url);
        }
    };

    const handleModalClose = () => {
        setModalOpen(false);
    };

    const handleShareOptionClick = (url, socialType) => {
        switch (socialType) {
          case 'WhatsApp':
            handleWhatsappShare(url);
            break;
          case 'Gmail':
            handleGmailShare('IPF Clinical study', url, 'Check out this link:');
            break;
          case 'Copy':
            copyToClipboard(url);
            break;
          default:
            break;
        }
        setModalOpen(false);
    };

    const handleWhatsappShare = async (url) => {
        try {
          if (!url || typeof url !== 'string' || url.length === 0) {
            throw new Error('URL is required for sharing.');
          }
    
          const message = encodeURIComponent(`Check out this link: ${url}`);
          const whatsappUrl = `whatsapp://send?text=${message}`;
          window.open(whatsappUrl);
        } catch (error) {
          console.error('WhatsApp sharing error:', error.message);
        }
      };
    
      const handleGmailShare = (subject, body, text) => {
        try {
          if (!subject || !body) {
            throw new Error('Subject and body are required for sharing via Gmail.');
          }
          const encodedSubject = encodeURIComponent(subject);
          const encodedBody = encodeURIComponent(`${text}\n\n${body}`);
          const gmailUrl = `mailto:?subject=${encodedSubject}&body=${encodedBody}`;
    
          window.location.href = gmailUrl;
        } catch (error) {
          console.error('Gmail sharing error:', error.message);
        }
      };
        

    const copyToClipboard = () => {
        const currentURL = window.location.href;
    
        if (navigator.clipboard) {
          navigator.clipboard.writeText(currentURL)
            .then(() => {
              console.log('URL copied to clipboard');
              toast.success('URL copied to clipboard');
            })
            .catch((err) => {
              console.error('Error copying to clipboard', err);
              toast.success('URL copied to clipboard');
            });
        } else {
          const textArea = document.createElement('textarea');
          textArea.value = currentURL;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          console.log('URL copied to clipboard');
          toast.success('URL copied to clipboard');
        }
      };

  return (
    //header html code
    <section className="footer">
        <div className="container">
            <ul className="nav navbar-nav">
                <li>
                    <Link to = "/" onClick={() => navigateToSection('home')} > Home  </Link >
                </li>
                <li>
                    <Link to = "/#aboutStudy"  onClick={() => navigateToSection('aboutStudy')} > About the Trial  </Link >
                </li>
                <li>
                    <Link to = "/#eligibility"  onClick={() => navigateToSection('eligibility')} > Eligibility  </Link >
                </li>
                <li>
                    <Link to="/faqs">FAQs</Link>
                </li>
                {/* <li>
                    <Link to="/location" onClick={() => navigateToSection('location')}>Locations</Link>                
                </li> */}
                {/* <li>
                    <Link target='_blank' to="https://clinicaltrials.gov/study/NCT05964335">For Healthcare Providers</Link>                
                </li> */}
                <li className="navbar-right">
                    <Link className="share" to="" onClick={() => showShareDialog(window.location.href)} alt="share page">Share this page</Link>
                </li>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar
                    newestOnTop={false}
                    closeOnClick={true}
                    rtl={false}
                    pauseOnFocusLoss={false}
                    draggable={false}
                    pauseOnHover={false}
                    theme='dark'
                    closeButton= {false}
                />
            </ul>
            <hr/>
            <div className="footer-bottom-nav">
                <div className="row">
                    <div className="col-12 col-sm-4">
                    <span className='custom_span'>© 2024 Indegene.<br/>
                    </span>
                    </div>
                    <div className="col-12 col-sm-8">
                        <ul>
                        <li>
                                <Link to="/cookies" alt="Cookies Policy">Cookies Policy </Link>
                            </li>
                            
                            <li>
                                <Link 
                                // onClick={() => openPDFInNewTab(pdfPaths.termsOfService)} 
                                alt="terms and condition">Terms of Service </Link>
                            </li>
                            <li>
                                <Link 
                                // onClick={() => openPDFInNewTab(pdfPaths.privacyPolicy)} 
                                alt="privacy policy">Privacy Policy</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <Modal show={modalOpen} onHide={handleModalClose} className="text-center">
                <Modal.Header closeButton>
                    <Modal.Title>Share Options</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <Button                            
                            className="share-btn mb-2"
                            onClick={() => handleShareOptionClick(window.location.href, 'WhatsApp')}
                            >WhatsApp <FaWhatsapp />
                        </Button>
                    
                        <Button                            
                            className="share-btn mb-2"
                            onClick={() => handleShareOptionClick(window.location.href, 'Gmail')}
                            >Gmail <FaEnvelope />
                        </Button>
                   
                        <Button                            
                            className="share-btn mb-2"
                            onClick={() => handleShareOptionClick(window.location.href, 'Copy')}
                            >Copy <FaCopy />
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    </section>
  );
};

export default Footer;
